<script>
  import { onMount, onDestroy } from 'svelte';
  import { fade, fly } from 'svelte/transition';
  import { DASHBOARD_CONFIG, getStatusLabel } from '../../config.js';
  import PowerTechLogo from '../Brand/PowerTechLogo.svelte';

  const statusTints = DASHBOARD_CONFIG.loadingTints;

  const messages = [
    'Sincronizando pedidos con PocketBase…',
    'Organizando columnas por estado…',
    'Preparando repartidores, escoltas y pickers…',
    'Aplicando filtros de fecha y sucursal…',
    'Casi listo. Tu tablero está por aparecer…',
  ];

  $: columns = DASHBOARD_CONFIG.displayStatuses;
  $: rows = Array(Math.ceil(columns.length / 3));

  let messageIndex = 0;
  let interval;

  onMount(() => {
    interval = setInterval(() => {
      messageIndex = (messageIndex + 1) % messages.length;
    }, 2800);
  });

  onDestroy(() => {
    clearInterval(interval);
  });
</script>

<div class="dashboard-loading px-2 sm:px-4">
  <div class="loading-header mb-6 flex flex-col items-center w-full" in:fade={{ duration: 400 }}>
    <div class="mb-4 w-full flex justify-center">
      <PowerTechLogo size="lg" />
    </div>

    <h3 class="text-lg font-bold text-blueGray-800 mb-2 text-center w-full">Estado de Pedidos</h3>

    <div class="h-1.5 w-full max-w-md mx-auto rounded-full bg-blueGray-200 overflow-hidden mb-3">
      <div class="loading-bar h-full rounded-full"></div>
    </div>

    {#key messageIndex}
      <p class="text-sm text-blueGray-600 font-medium min-h-[1.25rem] text-center w-full" in:fade={{ duration: 350 }}>
        {messages[messageIndex]}
      </p>
    {/key}
  </div>

  {#each rows as _, rowIndex}
    <div class="flex flex-wrap {rowIndex > 0 ? 'mt-4' : ''}">
      {#each columns.slice(rowIndex * 3, (rowIndex + 1) * 3) as status, colIndex}
        <div
          class="w-full xl:w-4/12 mb-12 xl:mb-0 px-4"
          in:fly={{ y: 24, duration: 500, delay: (rowIndex * 3 + colIndex) * 80 }}
        >
          <div
            class="rounded border shadow-lg overflow-hidden bg-gradient-to-b {statusTints[status] || 'from-gray-100 to-gray-50 border-gray-200'}"
            style="height: 480px;"
          >
            <div class="px-4 py-3 border-b border-white border-opacity-60 bg-white bg-opacity-40">
              <p class="text-xs font-bold uppercase text-blueGray-700 tracking-wide">
                {getStatusLabel(status)}
              </p>
            </div>

            <div class="p-4 space-y-3">
              {#each [0, 1, 2] as cardIndex}
                <div
                  class="rounded-lg border border-white border-opacity-70 bg-white bg-opacity-60 p-3 space-y-2"
                  style="animation-delay: {(rowIndex * 3 + colIndex) * 120 + cardIndex * 90}ms"
                >
                  <div class="flex justify-between gap-2">
                    <div class="shimmer h-3 flex-1 rounded"></div>
                    <div class="shimmer h-3 w-10 rounded"></div>
                  </div>
                  <div class="shimmer h-2 w-24 rounded"></div>
                  <div class="shimmer h-2 w-full rounded"></div>
                  <div class="shimmer h-2 w-3/4 rounded"></div>
                </div>
              {/each}
            </div>
          </div>
        </div>
      {/each}
    </div>
  {/each}
</div>

<style>
  .loading-header :global(.brand-logo) {
    display: flex;
    justify-content: center;
    width: 100%;
  }

  .loading-header :global(.brand-logo img) {
    margin-left: auto;
    margin-right: auto;
  }

  .loading-bar {
    width: 40%;
    background: linear-gradient(90deg, #dc2626, #ef4444, #dc2626);
    background-size: 200% 100%;
    animation: loadingBar 1.6s ease-in-out infinite;
  }

  .shimmer {
    background: linear-gradient(
      90deg,
      rgba(148, 163, 184, 0.25) 0%,
      rgba(148, 163, 184, 0.45) 50%,
      rgba(148, 163, 184, 0.25) 100%
    );
    background-size: 200% 100%;
    animation: shimmer 1.4s ease-in-out infinite;
  }

  @keyframes shimmer {
    0% {
      background-position: 200% 0;
    }
    100% {
      background-position: -200% 0;
    }
  }

  @keyframes loadingBar {
    0% {
      transform: translateX(-120%);
      background-position: 0% 50%;
    }
    100% {
      transform: translateX(320%);
      background-position: 100% 50%;
    }
  }
</style>
